import React from "react";

function ErrorInfo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
    >
      <g
        id="Group_27959"
        data-name="Group 27959"
        transform="translate(-891 -822)"
      >
        <circle
          id="Ellipse_2360"
          data-name="Ellipse 2360"
          cx="40"
          cy="40"
          r="40"
          transform="translate(891 822)"
          fill="#fff"
          opacity="0.5"
        />
        <g
          id="Group_27958"
          data-name="Group 27958"
          transform="translate(908.631 839.25)"
        >
          <path
            id="Path_16059"
            data-name="Path 16059"
            d="M0,0H46.7V46.7H0Z"
            fill="none"
          />
          <path
            id="Path_18892"
            data-name="Path 18892"
            d="M17.455,32.911A15.455,15.455,0,1,1,32.911,17.455,15.455,15.455,0,0,1,17.455,32.911Zm0-3.091A12.364,12.364,0,1,0,5.091,17.455,12.364,12.364,0,0,0,17.455,29.82ZM15.91,9.728H19v3.091H15.91Zm0,6.182H19v9.273H15.91Z"
            transform="translate(6.006 6.006)"
            fill="#03f"
          />
        </g>
      </g>
    </svg>
  );
}

export default ErrorInfo;
